/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var isSelectionEnabled = function isSelectionEnabled(props) {
  var selected = props.selected,
    defaultSelected = props.defaultSelected,
    enableSelection = props.enableSelection,
    cellSelection = props.cellSelection,
    checkboxColumn = props.checkboxColumn;
  if (enableSelection !== undefined) {
    return !!enableSelection;
  }
  return selected !== undefined || defaultSelected !== undefined && cellSelection === undefined || !!checkboxColumn;
};
var _default = isSelectionEnabled;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/hooks/useSelection/isSelectionEnabled.js
// module id = 223
// module chunks = 0